import * as yup from 'yup'

export default defineNuxtPlugin((nuxtApp) => {
  yup.setLocale({
    mixed: {
      required: 'Это поле обязательно для заполнения',
    },
    string: {
      email: 'Введите корректный email',
      min: ({ min }) => `Минимальная длина: ${min} символов`,
    },
    array: {
      min: ({ min }) => `Минимальное количество элементов: ${min}`,
    },
  })
})
